// src/firebase.js
import { initializeApp, getApps } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";

const getEnv = (k) => (process.env && process.env[k]) || "";

const firebaseConfig = {
  apiKey: getEnv("REACT_APP_FB_API_KEY"),
  authDomain: getEnv("REACT_APP_FB_AUTH_DOMAIN"),
  projectId: getEnv("REACT_APP_FB_PROJECT_ID"),
  storageBucket: getEnv("REACT_APP_FB_STORAGE_BUCKET"),
  messagingSenderId: getEnv("REACT_APP_FB_MESSAGING_SENDER_ID"),
  appId: getEnv("REACT_APP_FB_APP_ID"),
  measurementId: getEnv("REACT_APP_FB_MEASUREMENT_ID"),
};

export const app = getApps().length ? getApps()[0] : initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// GIỮ NGUYÊN để dùng callable sau này nếu muốn
export const FUNCTIONS_REGION = getEnv("REACT_APP_FUNCTIONS_REGION") || "asia-southeast1";
export const functions = getFunctions(app, FUNCTIONS_REGION);

// QUAN TRỌNG: chỉ lấy endpoint từ env, KHÔNG fallback
export const CF_NLQUERY_ENDPOINT = (getEnv("REACT_APP_CF_NLQUERY_ENDPOINT") || "").trim();
export const USE_AUTH = (getEnv("REACT_APP_USE_AUTH") || "false").toLowerCase() === "true";
export const USE_EMULATOR = (getEnv("REACT_APP_USE_EMULATOR") || "false").toLowerCase() === "true";
